import { render, staticRenderFns } from "./DataRepoProject.vue?vue&type=template&id=5fad0ff2&"
import script from "./DataRepoProject.vue?vue&type=script&lang=ts&"
export * from "./DataRepoProject.vue?vue&type=script&lang=ts&"
import style0 from "./DataRepoProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports